<template>
  <div class="app-container" v-loading="listLoading">
    <el-form
      ref="form"
      :rules="rules"
      :model="form"
      label-position="left"
      label-width="70px"
      style="width:90%;height:700px;margin-left:50px;"
    >
      <el-form-item label="店铺名称" prop="weight" label-width="130px">
        <el-col :span="13">
          <el-input v-model="form.name" placeholder="单行输入" :clearable="true" />
        </el-col>
      </el-form-item>
      <!-- <el-form-item label="所在地" prop label-width="130px" :inline="true">
        <el-col :span="4">
          <div class="grid-content bg-purple">
            <el-select
              placeholder="省"
              v-model="form.province_id"
              @change="getCityList(1)"
              :clearable="true"
            >
              <el-option
                v-for="item in provinceList"
                :key="item.province_id"
                :label="item.name"
                :value="item.province_id"
              ></el-option>
            </el-select>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="grid-content bg-purple">
            <el-select
              placeholder="市"
              v-model="form.city_id"
              @change="getDistrictsList()"
              v-if="this.form.province_id"
              :clearable="true"
            >
              <el-option
                v-for="item in cityList"
                :key="item.city_id"
                :label="item.name"
                :value="item.city_id"
              ></el-option>
            </el-select>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="grid-content bg-purple">
            <el-select
              placeholder="区"
              v-model="form.district_id"
              v-if="this.form.city_id"
              :clearable="true"
            >
              <el-option
                v-for="item in districtList"
                :key="item.district_id"
                :label="item.name"
                :value="item.district_id"
              ></el-option>
            </el-select>
          </div>
        </el-col>
      </el-form-item>-->
      <el-form-item label="详细地址(非必填)" prop="description" label-width="130px">
        <el-col :span="13">
          <el-input type="textarea" :rows="3" v-model="form.address" />
        </el-col>
      </el-form-item>
      <el-form-item label="联系人" prop="weight" label-width="130px">
        <el-col :span="13">
          <el-input v-model="form.contact_name" placeholder :clearable="true" />
        </el-col>
      </el-form-item>
      <el-form-item label="联系人电话" prop="weight" label-width="130px">
        <el-col :span="13">
          <el-input v-model="form.contact_phone" placeholder :clearable="true" />
        </el-col>
      </el-form-item>
      <el-form-item label="客服电话" prop="weight" label-width="130px">
        <el-col :span="13">
          <el-input v-model="form.service_phone" placeholder />
        </el-col>
      </el-form-item>
      <el-form-item label="经纬度(非必填)" label-width="130px">
        <el-col :md="6">
          <div style="display:flex;">
            <el-input :disabled="true" v-model="position"></el-input>

            <el-button @click="clearPosition" type="danger" style="margin:0 0 0 10px">清除经纬度</el-button>
          </div>
        </el-col>
        <el-col :span="24" style="margin-top:15px;">
          <amap-position ref="map" @choosePosition="choosePosition" :height="300"></amap-position>
        </el-col>
      </el-form-item>
    </el-form>
    <el-col :span="24">
      <div style="margin:0 auto;width:150px;line-height:60px;">
        <!-- <el-button @click="goBack">取消</el-button> -->
        <el-button type="primary" @click="saveData" :loading="btnLoading">确定</el-button>
      </div>
    </el-col>
  </div>
</template>

<script>
import { getQiniuToken } from "@/api/common";
import request from "@/utils/request";
import { guid, base64toFile } from "@/utils/index";
import "babel-polyfill"; // es6 shim
import imgCropUpload from "vue-image-crop-upload";
import uploadList from "@/components/UploadList/index.vue";
import * as qiniu from "qiniu-js";
import AMapPosition from "@/components/AMapPosition";

export default {
  components: {
    "img-crop-upload": imgCropUpload,
    "amap-position": AMapPosition,
    uploadList
  },
  data() {
    return {
      position: null,
      list: null,
      total: null,
      listLoading: true,
      provinceList: [],
      cityList: [],
      districtList: [],
      listQuery: {
        page: 1,
        limit: 10
      },
      dialogFormVisible: false,
      dialogStatus: "",
      textMap: {
        update: "编辑",
        create: "添加"
      },
      dialogPvVisible: false,
      pvData: [],
      form: {
        name: ""
      },
      rules: {
        img: [{ required: true, message: "图片不能为空", trigger: "blur" }]
      },
      btnLoading: false,

      show: false,
      imgBase64Data: "" // the datebase64 url of created image
    };
  },
  created() {
    this.getShop();
  },
  methods: {
    choosePosition(res) {
      this.position = res.position.lat + "," + res.position.lng;
      this.form.latitude = res.position.lat;
      this.form.longitude = res.position.lng;
      this.form.address = res.address;
    },
    getShop() {
      this.listLoading = true;
      this.getProvinceList();
      this.getCityList();
      this.getDistrictsList();
      request({
        url: "/api/shop/shop",
        method: "get",
        params: ""
      }).then(res => {
        this.form = res.data;
        this.position = this.form.latitude + "," + this.form.longitude;
        this.position = res.data.latitude + " , " + res.data.longitude;
        if (res.data.latitude && res.data.longitude) {
          this.$refs["map"].setCenter(res.data.longitude, res.data.latitude);
        }
        if (!this.form.latitude) {
          this.position = "";
        }
        // this.form.province_id = this.form.province_id.toString();
        // this.form.city_id = this.form.city_id.toString();
        // this.form.district_id = this.form.district_id.toString();
        
        this.listLoading = false;
      });
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    resetForm() {
      this.form = {
        id: "",
        img: "",
        imgArray: [],
        link_type: 0,
        link: "",
        weight: 0,
        description: ""
      };
      this.btnLoading = false;
    },
    clearPosition() {
      this.position = "";
      this.form.latitude = "";
      this.form.longitude = "";
    },
    handleCreate() {
      this.resetForm();
      this.dialogStatus = "create";
      this.dialogFormVisible = true;
      this.$nextTick(() => {
        this.$refs["form"].clearValidate();
      });
    },
    handleUpdate(row) {
      this.resetForm();
      this.form = Object.assign(
        {
          imgArray: [
            "http://img.qkjcrm.com/c9fd9e7a-6e3c-42c7-8c9a-22c20cd3db22.png",
            "http://img.qkjcrm.com/f860dce0-04e4-49c4-926e-4a7a0360c8b0.png"
          ]
        },
        row
      ); // copy obj
      this.dialogStatus = "update";
      this.dialogFormVisible = true;
      this.$nextTick(() => {
        this.$refs["form"].clearValidate();
      });
    },
    saveData() {
      this.btnLoading = true;
      request({
        url: "/api/shop/shop",
        method: "post",
        data: this.form
      })
        .then(response => {
          this.btnLoading = false;
          this.dialogFormVisible = false;
          this.$notify({
            title: "成功",
            message: "保存成功",
            type: "success",
            duration: 2000
          });
          this.getList();
        })
        .catch(err => {
          this.btnLoading = false;
        });
    },
    handleDel(val) {
      this.$confirm("确定要删除, 是否继续?", "提示", {
        type: "warning"
      })
        .then(() => {
          request({
            url: "/api/backend/banner/del",
            method: "get",
            params: { id: val }
          }).then(() => {
            this.getList();
            this.$message({
              type: "success",
              message: "删除成功!"
            });
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },

    toggleShow() {
      this.show = !this.show;
    },
    cropSuccess(imgBase64Data, field) {
      console.log("-------- 裁剪成功 --------");
      let that = this;
      this.imgBase64Data = imgBase64Data;
      getQiniuToken().then(response => {
        let file = base64toFile(imgBase64Data, "tmp.png");
        let key = guid() + ".png";
        let token = response.data.token;
        let baseUrl = response.data.baseUrl;
        let putExtra = {};
        let config = {
          useCdnDomain: true,
          region: qiniu.region.z2
        };
        var observable = qiniu.upload(file, key, token, putExtra, config);
        var subscription = observable.subscribe({
          next(res) {
            // ...
          },
          error(err) {
            // ...
          },
          complete(res) {
            // ...
            let imgUrl = baseUrl + "/" + key;
            that.form.img = imgUrl;
            console.log(imgUrl);
          }
        }); // 上传开始
        // or
        // var subscription = observable.subscribe(next, error, complete) // 这样传参形式也可以
        // subscription.unsubscribe() // 上传取消
      });
    },
    getProvinceList() {
      request({
        url: "/api/common/area/index",
        method: "get",
        params: ""
      }).then(response => {
        this.provinceList = response.data;
      });
    },
    getCityList(type) {
      if (type == 1) {
        this.form.city_id = "";
        this.form.district_id = "";
      }
      request({
        url: "/api/common/area/cities",
        method: "get",
        params: { province_id: this.form.province_id }
      }).then(response => {
        this.cityList = response.data;
      });
    },
    getDistrictsList() {
      request({
        url: "/api/common/area/districts",
        method: "get",
        params: { city_id: this.form.city_id }
      }).then(response => {
        this.districtList = response.data;
      });
    }
  }
};
</script>


<style>
.upload-block {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 120px;
  height: 120px;
}
.uploaded-img {
  width: 120px;
  height: 120px;
}
.upload-block:hover {
  border-color: #409eff;
}
.uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 120px;
  height: 120px;
  line-height: 120px;
  text-align: center;
}
</style>
